module.exports = require('./../dist/src/system/dist/components/CloseLarge.js');
